import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Package, DownloadCloud, Users } from 'lucide-react';
interface SoftwareDistributionProps {
  onLogout: () => void;
}
export function SoftwareDistribution({
  onLogout
}: SoftwareDistributionProps) {
  return <MainLayout title="Softwareverteilung (MDM)" onLogout={onLogout} data-id="element-1243">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1244">
        <Card title="Software Pakete" className="lg:col-span-2" data-id="element-1245">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1246">
            {[{
            name: 'Microsoft Office 365',
            version: 'v16.0.1',
            size: '2.4 GB',
            type: 'Productivity'
          }, {
            name: 'Adobe Acrobat Reader',
            version: '2023.001',
            size: '450 MB',
            type: 'Utility'
          }, {
            name: 'Google Chrome Enterprise',
            version: 'v118',
            size: '120 MB',
            type: 'Browser'
          }, {
            name: '7-Zip',
            version: '23.01',
            size: '5 MB',
            type: 'Utility'
          }, {
            name: 'TeamViewer Host',
            version: 'v15',
            size: '80 MB',
            type: 'Support'
          }, {
            name: 'VLC Media Player',
            version: '3.0.18',
            size: '40 MB',
            type: 'Media'
          }].map((app, idx) => <div key={idx} className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-teal-500 transition-colors" data-id="element-1247">
                <div className="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center mr-4" data-id="element-1248">
                  <Package className="h-5 w-5 text-slate-600" data-id="element-1249" />
                </div>
                <div className="flex-1" data-id="element-1250">
                  <h4 className="font-medium text-slate-900" data-id="element-1251">{app.name}</h4>
                  <div className="flex items-center gap-2 text-xs text-slate-500" data-id="element-1252">
                    <span data-id="element-1253">{app.version}</span>
                    <span data-id="element-1254">•</span>
                    <span data-id="element-1255">{app.size}</span>
                  </div>
                </div>
                <Button size="sm" variant="ghost" icon={<DownloadCloud className="h-4 w-4" data-id="element-1257" />} data-id="element-1256">
                  Deploy
                </Button>
              </div>)}
          </div>
        </Card>

        <div className="space-y-6" data-id="element-1258">
          <Card title="Deployment Status" data-id="element-1259">
            <div className="space-y-4" data-id="element-1260">
              <div data-id="element-1261">
                <div className="flex justify-between text-sm mb-1" data-id="element-1262">
                  <span className="font-medium" data-id="element-1263">
                    Chrome Update (Alle Clients)
                  </span>
                  <span className="text-slate-500" data-id="element-1264">85%</span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-1265">
                  <div className="bg-teal-500 h-2 rounded-full" style={{
                  width: '85%'
                }} data-id="element-1266"></div>
                </div>
              </div>

              <div data-id="element-1267">
                <div className="flex justify-between text-sm mb-1" data-id="element-1268">
                  <span className="font-medium" data-id="element-1269">Office 365 Rollout</span>
                  <span className="text-slate-500" data-id="element-1270">42%</span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-1271">
                  <div className="bg-blue-500 h-2 rounded-full" style={{
                  width: '42%'
                }} data-id="element-1272"></div>
                </div>
              </div>
            </div>
          </Card>

          <Card title="MDM Gruppen" data-id="element-1273">
            <div className="space-y-2" data-id="element-1274">
              <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer" data-id="element-1275">
                <div className="flex items-center gap-3" data-id="element-1276">
                  <Users className="h-4 w-4 text-slate-500" data-id="element-1277" />
                  <span className="text-sm" data-id="element-1278">Alle Windows Clients</span>
                </div>
                <Badge variant="secondary" data-id="element-1279">142</Badge>
              </div>
              <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer" data-id="element-1280">
                <div className="flex items-center gap-3" data-id="element-1281">
                  <Users className="h-4 w-4 text-slate-500" data-id="element-1282" />
                  <span className="text-sm" data-id="element-1283">Vertrieb Notebooks</span>
                </div>
                <Badge variant="secondary" data-id="element-1284">28</Badge>
              </div>
              <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer" data-id="element-1285">
                <div className="flex items-center gap-3" data-id="element-1286">
                  <Users className="h-4 w-4 text-slate-500" data-id="element-1287" />
                  <span className="text-sm" data-id="element-1288">Management</span>
                </div>
                <Badge variant="secondary" data-id="element-1289">12</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </MainLayout>;
}